import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { Observable } from "rxjs/index";
import { Oauth2 } from "../modules/auth/libs/oauth2";
import { AppService } from "../services/app.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const headers = {
      // 'Content-Type': 'application/json; charset=utf-8',
      // 'Accept': 'application/json',
    };

    const app = this.injector.get(AppService);

    if (app.getAuthService().isAuthenticated()) {
      headers["Authorization"] = `Bearer ${app.getAuthService().getToken()}`;
    }

    req = req.clone({
      setHeaders: headers,
    });

    if (
      app.getAuthService().driver instanceof Oauth2 &&
      app.getAuthService().isAuthenticated()
    ) {
      if (req.body) {
        Object.assign(req.body, {
          Context: {
            Identity: {
              UserType: "Staff",
            },
          },
        });
      }
    }

    return next.handle(req);
  }
}
